import React from "react";
import classNames from "classnames";
import { Button } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";

import ProgressiveCarousel from "../../components/ProgressiveCarousel";
import { PlayIcon } from "../../components/Icons";
import styles from "./HeroStyles";
import { GooglePlayBadge } from "../../components/AppBadges";
import { isMobile } from "../../userAgentDetect";

const carouselImages = [
  {
    label: "Photo mosaic of a woman with sunglasses",
    id: "WomanWithSunglasses.jpg",
    bgColor: "#86817a"
  },
  {
    label: "Photo mosaic of two girls covering their eyes with hats",
    id: "girlsWithHats.jpg",
    bgColor: "#86817a"
  },
  {
    label: "Photo mosaic of a red telephone box",
    id: "RedTelephoneBox.jpg",
    bgColor: "#86817a"
  },
  {
    label: "Photo mosaic of an adorable dog",
    id: "dog.jpg",
    bgColor: "#86817a"
  },
  {
    label: "Photo mosaic of four classmates pose in classroom",
    id: "classmates.jpg",
    bgColor: "#86817a"
  }
];

class Hero extends React.Component {
  renderCallToActions() {
    const { classes, onHowToVideoClick } = this.props;
    if (isMobile) {
      return (
        <div className={classes.badges}>
          <GooglePlayBadge />
        </div>
      );
    }
    return (
      <React.Fragment>
        <Button
          onClick={onHowToVideoClick}
          size="large"
          variant="contained"
          color={isMobile ? "primary" : "default"}
          className={classNames(classes.ctaButton, {
            [classes.ctaButtonWhite]: !isMobile,
            [classes.ctaButtonContained]: isMobile
          })}
        >
          <PlayIcon className={classes.ctaButtonIcon} />
          How-to video
        </Button>
        <Button
          component={Link}
          to="/create/mosaic/step1"
          size="large"
          variant="contained"
          color="primary"
          className={classes.ctaButton}
        >
          Get started
        </Button>
      </React.Fragment>
    );
  }
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.hero}>
        <ProgressiveCarousel images={carouselImages} />
        <div className={classNames("mask", classes.mask)} />
        <div className={classes.taglineContainer}>
          <h3 className={classes.headline}>
            Your photo art journey starts right here
          </h3>
          <p className={classes.subheading}>
            Turn your photos into a photo mosaic and make it a special gift for
            your loved ones.
          </p>
          <div className={classes.ctaContainer}>
            {this.renderCallToActions()}
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(Hero);



// WEBPACK FOOTER //
// ./src/screens/Home/Hero.js